import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from '../popup/popup.component';
import { version } from 'src/app/constants/version.constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
})
export class FooterComponent {
  version = version.version;
  constructor(private dialog: MatDialog) {}
  openPrivacyPolicy() {
    this.dialog.open(PopupComponent, {
      data: { col: 'PrivacyPolicyComponent' },
    });
  }
}
